export default "__VITE_ASSET__Be8$Xx_i__"